import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import { LoopModule } from 'src/services/openApiV2'

const GuardTrends = lazy(() => import('src/pages/members/StoreAvailability/Navs/Trends'))
const GuardRestoreHistory = lazy(() => import('src/pages/members/StoreAvailability/Navs/RestoreHistory'))
const GuardRealtimeStatus = lazy(() => import('src/pages/members/StoreAvailability/Navs/RealtimeStatus'))
const GuardNotificationsSlack = lazy(() => import('src/pages/members/StoreAvailability/Navs/NotificationsSlack'))
const GuardHistoryByLostSales = lazy(() => import('src/pages/members/StoreAvailability/Navs/HistoryByLostSales'))
const GuardHistoryByAvgDowntime = lazy(() => import('src/pages/members/StoreAvailability/Navs/HistoryByAvgDowntime'))
const GuardHistoryByRestoreImpact = lazy(() => import('src/pages/members/StoreAvailability/Navs/HistoryByRestoreImpact'))
const GuardHistoryByUnfulfilledRate = lazy(() => import('src/pages/members/StoreAvailability/Navs/HistoryByUnfulfilledRate'))
const GuardHistoryByAvgAvoidableWaitTime = lazy(() => import('src/pages/members/StoreAvailability/Navs/HistoryByAvgAvoidableWaitTime'))
const GuardMatrix = lazy(() => import('src/pages/members/StoreAvailability/Navs/Matrix'))
const GuardDriverWaitTime = lazy(() => import('src/pages/members/DriverWaitTime/DriverWaitTime'))
const GuardRestoreConfig = lazy(() => import('src/pages/members/GuardRestoreConfig/GuardRestoreConfig'))
const Configurations = lazy(() => import('src/pages/members/Configurations/ConfigurationCenter'))
const Benchmarks = lazy(() => import('src/pages/members/Benchmarks/Benchmarks'))
const GuardProblematicItems = lazy(() => import('src/pages/members/GuardProblematicItems/GuardProblematicItems'))

export const existingRoutes = [
  // Legacy route redirects - underscore/slash format → hyphenated format
  // 2,326 pageviews in last 90 days for underscore routes
  {
    path: 'guard/realtime/status',
    element: <Navigate to="/guard/realtime-status" replace />
  },
  {
    path: 'guard/history/lost_sales',
    element: <Navigate to="/guard/history/lost-sales" replace />
  },
  {
    path: 'guard/history/average_downtime',
    element: <Navigate to="/guard/history/average-downtime" replace />
  },
  {
    path: 'guard/history/restore_impact',
    element: <Navigate to="/guard/history/restore-impact" replace />
  },
  {
    path: 'guard/history/unfulfilled_rate',
    element: <Navigate to="/guard/history/unfulfilled-rate" replace />
  },
  {
    path: 'guard/history/avoidable_wait_time',
    element: <Navigate to="/guard/history/avoidable-wait-time" replace />
  }
]

export const moduleNamedRoutes = [
  {
    path: 'guard',
    element: <GuardTrends />,
    children: [
      { index: true, element: <GuardTrends /> },
      { path: 'trends', element: <GuardTrends /> },
      {
        path: 'restore',
        children: [
          { index: true, element: <GuardRestoreHistory /> },
          { path: 'history', element: <GuardRestoreHistory /> },
          { path: 'matrix', element: <GuardMatrix /> }
        ]
      },

      { path: 'realtime-status', element: <GuardRealtimeStatus /> },
      { path: 'driver-wait-time', element: <GuardDriverWaitTime /> },
      {
        path: 'configurations',
        children: [
          { index: true, element: <Configurations /> },
          { path: 'locations', element: <Configurations /> },
          { path: 'reasons', element: <GuardRestoreConfig /> }
        ]
      },
      {
        path: 'notifications',
        children: [
          { path: 'slack', element: <GuardNotificationsSlack /> },
        ]
      },
      {
        path: 'history',
        children: [
          { index: true, element: <GuardHistoryByLostSales /> },
          { path: 'lost-sales', element: <GuardHistoryByLostSales /> },
          { path: 'average-downtime', element: <GuardHistoryByAvgDowntime /> },
          { path: 'restore-impact', element: <GuardHistoryByRestoreImpact /> },
          { path: 'unfulfilled-rate', element: <GuardHistoryByUnfulfilledRate /> },
          { path: 'avoidable-wait-time', element: <GuardHistoryByAvgAvoidableWaitTime /> }
        ]
      },
      { path: 'benchmarks', element: <Benchmarks module={LoopModule.GUARD} /> },
      { path: 'problematic-items', element: <GuardProblematicItems /> }
    ]
  }
]

export const guardRoutes = [...existingRoutes, ...moduleNamedRoutes]
